setupDataFinance = function() {
    const dataFinance = document.querySelector('input[name="financing"]:checked')
    const dataFinanceLoan = document.querySelector('[data-finance="loan"]')
    const dataFinanceCash = document.querySelector('[data-finance="cash"]')

    switch (dataFinance.value) {
        case 'loan':
            dataFinanceLoan.style.display = 'block'
            dataFinanceCash.style.display = 'none'
            break;
        case 'cash':
            dataFinanceLoan.style.display = 'none'
            dataFinanceCash.style.display = 'block'
            break;
    }
}

drawChartPeriod = function (graphOptions, graphData) {
    graphData = [].concat([
        ['Period', 'Value', {role: "style"}]
    ], graphData)

    let data = google.visualization.arrayToDataTable(graphData)

    // Get chart container
    const container = document.querySelector('#chart_period')
    let optionsWidth = container.parentNode.offsetWidth

    // Set chart options
    const options = {
        'enableInteractivity': false,
        'fontSize': graphOptions.fontSize,
        'fontName': graphOptions.fontName,
        'width': optionsWidth,
        'height': graphOptions.height,
        'legend': {
            'position': 'none'
        },
        'bars': 'horizontal',
        'chartArea': {
            'left': graphOptions.chartAreaLeft,
            'top': graphOptions.chartAreaTop,
            'width': optionsWidth - graphOptions.chartAreaWidthAdjustment,
            'height': graphOptions.chartAreaHeight
        },
        'vAxis': {
            'textStyle': {
                'color': '#757575'
            },
        },
        'hAxis': {
            'textStyle': {
                'color': '#757575'
            },
            'format':'$#,###',
            'ticks': graphOptions.hAxisTicks,
            'gridlines': {
                'color': '#F5F5F5'
            },
            'baselineColor': '#F5F5F5'
        },
    }

    // Instantiate and draw our chart, passing in some options.
    let chart = new google.visualization.BarChart(container)

    google.visualization.events.addListener(chart, 'ready', function () {
        // moving x labels
        const labels = container.getElementsByTagName('text')

        Array.prototype.forEach.call(labels, function (label) {
            if (label.getAttribute('text-anchor') === 'end') {
                let xCoordinate = parseFloat(label.getAttribute('x'))
                label.setAttribute('x', xCoordinate - 12) //20
            }
        })

        // add gradient
        Array.prototype.forEach.call(container.getElementsByTagName('rect'), function (rect) {
            if (rect.getAttribute('fill') === '#2d82b7') {
                rect.setAttribute('fill', 'url(#chart-period-gradient) #2d82b7')
                rect.setAttribute('rx', '8') //border radius
                rect.setAttribute('ry', '8') //border radius
            }
        })

        // // create observer - when enableInteractivity = true
        // let observer = new MutationObserver(function () {
        //     // add gradient
        //     Array.prototype.forEach.call(container.getElementsByTagName('rect'), function (rect) {
        //         if (rect.getAttribute('fill') === '#2d82b7') {
        //             rect.setAttribute('fill', 'url(#chart-period-gradient) #2d82b7')
        //             rect.setAttribute('rx', '8')
        //             rect.setAttribute('ry', '8')
        //         }
        //     })
        // })
        //
        // observer.observe(container, {
        //     childList: true,
        //     subtree: true
        // })
    })

    chart.draw(data, options)
}

drawChartSavings = function (graphOptions, graphData) {
    graphData = [].concat([
        ['Years', 'Savings', {role: 'style'}]
    ], graphData)

    let data = google.visualization.arrayToDataTable(graphData)

    // Get chart container
    const container = document.querySelector('#chart_savings')
    let optionsWidth = container.parentNode.offsetWidth

    // Set chart options
    const options = {
        'enableInteractivity': false,
        'fontSize': graphOptions.fontSize,
        'fontName': graphOptions.fontName,
        'height': graphOptions.height,
        'legend': {
            'position': 'none'
        },
        'chartArea': {
            'left': graphOptions.chartAreaLeft,
            'top': graphOptions.chartAreaTop,
            'width': optionsWidth - graphOptions.chartAreaWidthAdjustment,
            'height': graphOptions.chartAreaHeight
        },
        'vAxis': {
            'textStyle': {
                'color': '#757575'
            },
            'format':'$#K;$#K',
            // 'ticks': graphOptions.vAxisTicks,
            'gridlines': {
                'color': '#F5F5F5',
                'count': graphOptions.vAxisGridlinesCount
            },
            'baselineColor': '#F5F5F5',
        },
        'hAxis': {
            'textStyle': {
                'color': '#757575'
            },
            // 'ticks': graphOptions.hAxisTicks,
            'gridlines': {
                'color': 'transparent',
                'count': graphOptions.hAxisGridlinesCount
            },
            'baselineColor': '#FFFFFF'
        },
    }

    // Instantiate and draw our chart, passing in some options.
    let chart = new google.visualization.AreaChart(container)

    google.visualization.events.addListener(chart, 'ready', function () {
        // moving x labels
        const labels = container.getElementsByTagName('text')

        Array.prototype.forEach.call(labels, function (label) {
            if (label.getAttribute('text-anchor') === 'end') {
                let xCoordinate = parseFloat(label.getAttribute('x'))
                label.setAttribute('x', xCoordinate - 10);
            }
        })

        // add gradient
        Array.prototype.forEach.call(container.getElementsByTagName('path'), function (path) {
            if (path.getAttribute('fill') === '#ed6a5a') {
                path.setAttribute('fill', 'url(#chart-savings-gradient-negative) #ed6a5a')
            }
            if (path.getAttribute('fill') === '#52b6fa') {
                path.setAttribute('fill', 'url(#chart-savings-gradient-positive) #52b6fa')
            }
        })
    })

    chart.draw(data, options)
}

setupResults = function (graphDataPeriod, graphDataSavings) {
    setupDataFinance()
    document.querySelectorAll('input[name="financing"]').forEach(radio => radio.addEventListener('click', setupDataFinance))

    const resultsModal = document.querySelector('#resultsModal')
    const modalBackdrop = document.querySelector('#modalBackdrop')

    resultsModal.style.display = 'block'
    resultsModal.querySelectorAll('.resultsModalClose').forEach(element => {
        element.addEventListener('click', function() {
            resultsModal.style.display = 'none'
            modalBackdrop.style.display = 'none'
        })
    })

    graphDataPeriod.options.fontSize = 18 //16
    graphDataPeriod.options.fontName = 'Nunito Sans'
    graphDataPeriod.options.height = 360 //180
    graphDataPeriod.options.chartAreaWidthAdjustment = 120 //80
    graphDataPeriod.options.chartAreaLeft = 85 //75
    graphDataPeriod.options.chartAreaTop = 0
    graphDataPeriod.options.chartAreaHeight = 240 //160

    graphDataSavings.options.fontSize = 18 //16
    graphDataSavings.options.fontName = 'Nunito Sans'
    graphDataSavings.options.height = 500 //340
    graphDataSavings.options.chartAreaWidthAdjustment = 120 //80
    graphDataSavings.options.chartAreaLeft = 85 //75
    graphDataSavings.options.chartAreaTop = 20
    graphDataSavings.options.chartAreaHeight = 400 //300
    graphDataSavings.options.vAxisGridlinesCount = 8 //6
    graphDataSavings.options.hAxisGridlinesCount = 6 //4

    if (window.screen.width <= 576) {
        graphDataPeriod.options.fontSize = 16
        graphDataPeriod.options.height = 180
        graphDataPeriod.options.chartAreaWidthAdjustment = 80
        graphDataPeriod.options.chartAreaLeft = 75
        graphDataPeriod.options.chartAreaHeight = 160

        graphDataSavings.options.fontSize = 16
        graphDataSavings.options.height = 340
        graphDataSavings.options.chartAreaWidthAdjustment = 80
        graphDataSavings.options.chartAreaLeft = 75
        graphDataSavings.options.chartAreaTop = 20
        graphDataSavings.options.chartAreaHeight = 300
        graphDataSavings.options.vAxisGridlinesCount = 6
        graphDataSavings.options.hAxisGridlinesCount = 6
    }

    google.charts.load('current', {
        packages: ['corechart']
    }).then(function () {
        drawChartPeriod(graphDataPeriod.options, graphDataPeriod.data)
        drawChartSavings(graphDataSavings.options, graphDataSavings.data)
    })
}
